import React from 'react'
import Rectangle from 'blocks.simple/rectangle/rectangle'
import Button from 'blocks.simple/button/button'
import ItemAdvertisingCampaigns, {
    hasAdvertisementLinkedDevices,
} from '../../__item/_advertisingCampaigns/catalog__item_advertisingCampaigns'
import Tippy from 'blocks.simple/tippy/tippy'
import { api } from 'core/api/ConnectionManager'
import helpers from 'core/helpers'
import translate from 'core/translate'
import styles from './catalog__template_advertisingCampaigns.jcss'
import { routes } from 'features/routes'
import { colors, getThemeStyleValue } from 'theme/colors'
import { defaultThemeStyles } from 'blocks.simple/icon/icon.theme'
import { changeLocation } from 'features/routes'
import { ItemData } from '../../../../core/models/Template'
import Icon from '../../../../blocks.simple/icon/icon'
import { TActionType } from '../../../../core/models/Roles'
import {
    IActionToPermission,
    IActionToPermissionMap,
    IRequiredActionsForActionMap,
} from '../../../../organisms/TreeViewCatalog/TreeViewCatalogList/TreeViewCatalogList-types'
import { TTreeViewTypeInstances } from '../../../../core/helpers/treeView'

export default {
    wrapperClassName: styles.wrapper,
    similarTemplate: (path?: string, query?: any) => {
        return {
            getMethod:
                path === '/advertisingAds' ||
                (query && query.reportType === 'advertisingAds') ||
                path?.includes('/users/roles/')
                    ? 'getAdvertisements'
                    : 'getAdvertisingCampaigns',
        }
    },
    emptySearchText: () => translate('notFound'),
    emptyFolderText: (path?: string, search?: string) => {
        if (path === '/reports' && search && search.includes('advertisingAds')) return translate('noAdvertisement')

        return translate(path === '/advertisingAds' ? 'noAdvertisement' : 'noAdv')
    },
    mediaCellClassName: styles.mediaCellClassName,
    emptyIcon: 'not_allow',
    addItemButton: (self?: any, path?: any) => {
        return path.includes('/users/roles/') ? null : (
            <Button
                rounded="full_md"
                mod="withShadow"
                onClick={() =>
                    changeLocation(
                        path === '/advertisingAds'
                            ? `/${routes.addAdvertisingAds.path}`
                            : `/${routes.addAdvertisingCampaign.path}`
                    )
                }
            >
                {translate('add')}
            </Button>
        )
    },
    settingsPrefixes: 'advertisingCampaign',
    tile: ItemAdvertisingCampaigns,
    dateFilterOptions: () => [
        { id: 'completed', name: translate('completed') },
        { id: 'current', name: translate('current') },
        { id: 'upcoming', name: translate('upcoming') },
    ],
    viewOptions: () => [
        {
            id: 'tile',
            name: translate('tile'),
            icon: 'tile',
            iconColor: getThemeStyleValue('ui', 'icon', 'disable') || defaultThemeStyles.disable,
            iconActiveColor: getThemeStyleValue('ui', 'icon', 'active') || defaultThemeStyles.active,
        },
        {
            id: 'list',
            name: translate('list'),
            icon: 'list',
            iconColor: getThemeStyleValue('ui', 'icon', 'disable') || defaultThemeStyles.disable,
            iconActiveColor: getThemeStyleValue('ui', 'icon', 'active') || defaultThemeStyles.active,
        },
    ],
    sortOptions: () => [
        { id: '-createdAt', name: translate('sortCreatedAt') },
        { id: 'title', name: translate('byNameAsc') },
    ],
    getItemModel: (dataItem: ItemData, getSelected: (item: { __view?: { selected: boolean } }) => boolean) => {
        const item = { ...dataItem }
        item.cover = helpers.getBroadcastCover(item.coverSource)

        if (!item.__view) {
            item.__view = {
                selected: getSelected(item),
            }
        }

        return item
    },
    getBackendModel: (item: { id: number }) => {
        return api.send('getAdvertisingCampaign', { id: item.id }, { hideLoader: true })
    },
    similarTemplateBackendModel: (item: { id: number }, path?: string) => {
        return path === '/advertisingAds' || path?.includes('/users/roles/')
            ? api.send('getAdvertisement', { id: item.id }, { hideLoader: true })
            : api.send('getAdvertisingCampaign', { id: item.id }, { hideLoader: true })
    },
    isEqual: (firstItem: { id: number }, secondItem: { id: number }) => firstItem.id === secondItem.id,
    onCreateListeners: [
        (cb: any, clearList: string[]) => api.addObserver('advertisingCampaignCreated', cb, clearList),
        (cb: any, clearList: string[]) => api.addObserver('advertisementCreated', cb, clearList),
    ],
    onUpdateListeners: [
        (cb: any, clearList: string[]) => api.addObserver('advertisingCampaignUpdated', cb, clearList),
        (cb: any, clearList: string[]) => api.addObserver('advertisementUpdated', cb, clearList),
    ],
    onDeleteListeners: [(cb: any, clearList: string[]) => api.addObserver('advertisingCampaignDeleted', cb, clearList)],
    onAdvertisementDeleteListeners: [
        (cb: any, clearList: string[]) => api.addObserver('advertisementDeleted', cb, clearList),
    ],
    isFolder: () => {},
    fields: () => {
        const list = [
            { id: 'cover', name: translate('advertisingCampaign') },
            { id: 'title', name: translate('name') },
            { id: 'createdAt', name: translate('createdAt') },
        ]

        if (window.location.hash.includes('/users/roles/')) {
            delete list[2]

            list[2] = { id: 'roleSettings', name: translate('                     ') }
        }

        return list
    },
    init(callback: any) {
        //@ts-ignore
        this.setState({ isInit: true, fields: this.template.fields() }, callback)
    },
    list: {
        cover: (item: { cover: { src: string; isIcon: boolean }; isDraft?: boolean }) => {
            const hasDevices = hasAdvertisementLinkedDevices(item)

            return (
                <div className={styles.image}>
                    <Rectangle width={2} height={1} src={item.cover.src} contain={item.cover.isIcon}>
                        <div className={styles.deviceStatus}>
                            <Tippy title={translate(hasDevices ? 'linkedDevices' : 'noLinkedDevices')}>
                                <div className={styles.deviceStatusIcon}>
                                    <Icon
                                        type={hasDevices ? 'display_on' : 'display_off'}
                                        size={14}
                                        color={hasDevices ? colors.online : colors.warning}
                                    />
                                </div>
                            </Tippy>
                        </div>
                    </Rectangle>
                </div>
            )
        },
        createdAt: ({ createdAt }: { createdAt: string }) => helpers.getFormattedLocalDate(createdAt, 'DD/MM/YYYY'),
        roleSettings: (item: any, active: any, p_: any) => {
            const permissions: any = p_.permissions

            const REQUIRED_ACTIONS_FOR_ACTION: IRequiredActionsForActionMap = {
                update: ['read'],
                delete: ['read', 'update'],
                replace: ['read', 'delete', 'update'],
            }
            const getFilterByPropertyObject = (type: TTreeViewTypeInstances) => {
                switch (type) {
                    case 'advertisingAds':
                        return {
                            advertisingAdsIds: [],
                        }
                    default:
                        return { id: [], folderId: [] }
                }
            }
            const getFilterByPropertyKey = (type: any, isDirectory: boolean) => {
                switch (type) {
                    case 'advertisingAds':
                        return {
                            advertisingAdsIds: [],
                        }
                    default:
                        if (isDirectory) {
                            return 'folderId'
                        }

                        return 'id'
                }
            }
            const getDefaultActionModel = (model: IActionToPermission, catalog: TTreeViewTypeInstances) => {
                return {
                    ...model,
                    active: true,
                    filterByProperty: {
                        ...getFilterByPropertyObject(catalog),
                    },
                }
            }
            const clonePermission = (permission: IActionToPermission): IActionToPermission => {
                //@ts-ignore
                return helpers.deepCopy(permission)
            }
            const getStatus = (action: TActionType) => {
                const currentPermission = permissions[action]

                if (!currentPermission || !currentPermission.hasOwnProperty('filterByProperty')) {
                    return false
                }

                const array = currentPermission.filterByProperty['advertisingAdsIds']

                return array && array.includes(item.id)
            }
            const handleOnClick = (action: TActionType) => {
                let currentPermission = permissions[action]
                let isSetRequired = false
                let isDeleteRequired = false

                if (!currentPermission.hasOwnProperty('filterByProperty')) {
                    currentPermission = getDefaultActionModel(permissions[action], 'advertisingAds')
                }

                // @ts-ignore
                const array = currentPermission.filterByProperty['advertisingAdsIds']

                if (array.includes(item.id)) {
                    array.splice(array.indexOf(item.id), 1)
                    isDeleteRequired = true
                } else {
                    array.push(item.id)
                    isSetRequired = true
                }

                const required = REQUIRED_ACTIONS_FOR_ACTION[action]
                let newPermissions: IActionToPermissionMap = {}

                if (required && isSetRequired) {
                    required.forEach((requiredAction: TActionType) => {
                        let requiredPermission = permissions[requiredAction]

                        if (requiredPermission) {
                            if (!requiredPermission.hasOwnProperty('filterByProperty')) {
                                requiredPermission = getDefaultActionModel(requiredPermission, 'advertisingAds')
                            }

                            let updatedPermission = clonePermission(requiredPermission)
                            // @ts-ignore
                            const array = updatedPermission.filterByProperty['advertisingAdsIds']

                            if (!array.includes(item.id)) {
                                array.push(item.id)
                            }

                            newPermissions[requiredAction] = updatedPermission
                        }
                    })
                }

                let deletedPermissions: IActionToPermissionMap = {}

                if (isDeleteRequired) {
                    Object.entries(permissions).forEach(([permAction, permission]: any) => {
                        let requiredActions = REQUIRED_ACTIONS_FOR_ACTION[permAction]

                        if (requiredActions && requiredActions.includes(action)) {
                            if (!permission.hasOwnProperty('filterByProperty')) {
                                permission = getDefaultActionModel(permission, 'advertisingAds')
                            }

                            let newPermission = clonePermission(permission)

                            const permissionEntityList =
                                // @ts-ignore
                                newPermission.filterByProperty['advertisingAdsIds']

                            if (permissionEntityList.includes(item.id)) {
                                permissionEntityList.splice(permissionEntityList.indexOf(item.id), 1)
                            }

                            deletedPermissions[permAction] = newPermission
                        }
                    })
                }

                p_.onChangePermissions({ ...newPermissions, [action]: currentPermission, ...deletedPermissions })
            }

            return (
                <div className={styles.permissionsIconsWrapper}>
                    <div className={styles.actionIconWrapper}>
                        <Icon
                            className={styles.permissionsIcon}
                            type={'book'}
                            onClick={() => {
                                handleOnClick('read')
                            }}
                            color={getStatus('read') ? colors.blue : colors.blackLight}
                            tooltip={{
                                title: translate('readLabel'),
                            }}
                        />
                    </div>
                    <div className={styles.actionIconWrapper}>
                        <Icon
                            className={styles.permissionsIcon}
                            type={'pencil'}
                            onClick={() => {
                                handleOnClick('update')
                            }}
                            color={getStatus('update') ? colors.blue : colors.blackLight}
                            tooltip={{
                                title: translate('update'),
                            }}
                        />
                    </div>
                    <div className={styles.actionIconWrapper}>
                        <Icon
                            className={styles.permissionsIcon}
                            type={'delete'}
                            onClick={() => {
                                handleOnClick('delete')
                            }}
                            color={getStatus('delete') ? colors.blue : colors.blackLight}
                            tooltip={{
                                title: translate('delete'),
                            }}
                        />
                    </div>
                </div>
            )
        },
    },
}
